import React, { useState } from "react";
import { toast } from "sonner";
import { Phone } from "lucide-react";
import { api } from "@/lib/api";

// Shows a tel: link when the number is visible; otherwise "Show number" via the existing reveal-contact flow (₹1 wallet charge).
export const RevealCall = ({ listing, className, label, testid, compact = false }) => {
  const [num, setNum] = useState(listing.contact_masked ? null : listing.owner_mobile);
  const [busy, setBusy] = useState(false);
  if (!listing.owner_mobile) return null;
  const reveal = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/listings/${listing.listing_id}/reveal-contact`);
      setNum(data.mobile);
      if (data.charged_paise) toast.success("Number revealed · ₹1 charged from wallet");
    } catch (e) {
      const s = e?.response?.status;
      toast.error(s === 401 ? "Sign in to see the number" : s === 402 ? "Top up your wallet (₹1) to view this number" : "Could not reveal number");
    } finally { setBusy(false); }
  };
  if (num) {
    return (
      <a href={`tel:${num}`} className={className} data-testid={testid} title={`Call ${listing.owner_name || ""}`} aria-label="Call provider">
        <Phone size={compact ? 18 : 16} />{!compact && <> {label || num}</>}
      </a>
    );
  }
  return (
    <button type="button" onClick={reveal} disabled={busy} className={className} data-testid={`${testid}-reveal`}
            title="Show number (₹1)" aria-label="Show phone number">
      <Phone size={compact ? 18 : 16} />{!compact && <> {busy ? "…" : `Show number ${listing.owner_mobile}`}</>}
    </button>
  );
};
